import { useMemo } from 'react'
import { useStyletron } from 'baseui'
import buildPulseTheme from './buildPulseTheme'

const usePulseScopeTheme = () => {
  const [, theme] = useStyletron()

  return useMemo(() => buildPulseTheme(theme), [theme])
}

export default usePulseScopeTheme
